import { APIS } from '@/constants';
import axios from 'axios';

const tendermintRpc = {
  /**
   * Get block by height
   * @param {Number} height
   * @returns {AxiosPromise}
   * @note SDK 0.50: Path changed from /blocks/{height} to /cosmos/base/tendermint/v1beta1/blocks/{height}
   */
  requestBlock(height) {
    return axios({
      url: `/${height}`,
      method: 'get',
      baseURL: APIS.HTTP.BLOCKS,
    });
  },
  /**
   * Get latest block
   * @returns {AxiosPromise}
   * @note SDK 0.50: Path changed from /blocks/latest to /cosmos/base/tendermint/v1beta1/blocks/latest
   */
  requestBlockLatest() {
    return axios({
      url: '/latest',
      method: 'get',
      baseURL: APIS.HTTP.BLOCKS,
    });
  },
  /**
   * Get validator set by height
   * @param {Number} height
   * @returns {AxiosPromise}
   * @note SDK 0.50: Path changed from /validatorsets/{height} to /cosmos/base/tendermint/v1beta1/validatorsets/{height}
   */
  requestValidatorSets(height) {
    return axios({
      url: `/${height}`,
      method: 'get',
      baseURL: APIS.HTTP.VALIDATORSETS,
    });
  },
  /**
   * Get latest validator set
   * @returns {AxiosPromise}
   * @note SDK 0.50: Path changed from /validatorsets/latest to /cosmos/base/tendermint/v1beta1/validatorsets/latest
   */
  requestValidatorSetsLatest() {
    return axios({
      url: '/latest',
      method: 'get',
      baseURL: APIS.HTTP.VALIDATORSETS,
    });
  },
};

export default tendermintRpc;
